import { CurrencyFormatter } from '@utils/formatters/CurrencyFormatter';
import { NEXT_PUBLIC_NO_PRICE_FALLBACK } from '@config/environment';
import { useQuery } from '@apollo/client';
import {
  GetCheckoutPaymentMethodQueryResponse,
  GetCheckoutPaymentMethodQueryParams,
  getCheckoutPaymentMethod,
} from '@queries/checkout/queries/paymentMethod';
import { useOrderState } from '@hooks/useOrderState';
import {
  usePaymentMethodActions,
  usePaymentSelectors,
} from '../zustand/paymentMethodStore';
import { useMekiState } from '@hooks/useMekiState';
import { useCallback } from 'react';
import {
  ArrowIconContainer,
  SkeletonOptionDescriptionText,
  OptionDiv,
  TextDiv,
  OptionDescriptionText,
  OptionTitleText,
} from './PaymentsOptions.styles';
import {
  CardIconContainer,
  OptionLeftContainer,
  SkeletonOptionTitleText,
} from './PaymentsOptions.styles';

import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import { PaymentMethodMainCard } from '../styles';
import { CardIcon } from '@screens/checkout/components/CardIcon';
import { InteractionEventTypes } from '@validators/Events/Interactions';
import { useEventTracking } from '@hooks/useEventTracking';

interface MekiCreditsProps {
  loading: boolean;
}

export function MekiCredits({ loading }: MekiCreditsProps) {
  const { orderUuid } = useOrderState();
  const { track } = useEventTracking();

  const { data: orderAndUserInfoData, loading: loadingCredits } = useQuery<
    GetCheckoutPaymentMethodQueryResponse,
    GetCheckoutPaymentMethodQueryParams
  >(getCheckoutPaymentMethod(), {
    fetchPolicy: 'cache-first',
    variables: { params: { orderUuid } },
  });
  const { setInsuranceId, setInsuranceRut } = useMekiState();
  const { setMekiCreditsChecked } = usePaymentMethodActions();
  const handleMekiCreditsClick = useCallback(() => {
    setMekiCreditsChecked(true);
    setInsuranceId(null);
    setInsuranceRut(null);
    track(InteractionEventTypes.SelectMekiCredit);
  }, [setMekiCreditsChecked, setInsuranceId, setInsuranceRut]);

  const { currentUserInfo } = orderAndUserInfoData ?? {};
  const credits = currentUserInfo?.credits ?? 0;

  const currencyFormatter = new CurrencyFormatter({
    fallback: NEXT_PUBLIC_NO_PRICE_FALLBACK,
  });

  const label = `Créditos Meki: ${
    credits === 0 ? '$0' : currencyFormatter.format(credits)
  }`;
  if (loading) {
    return (
      <PaymentMethodMainCard>
        <OptionDiv key={0}>
          <OptionLeftContainer>
            <CardIconContainer />
            <TextDiv>
              <SkeletonOptionTitleText />
              <SkeletonOptionDescriptionText />
            </TextDiv>
          </OptionLeftContainer>
          <ArrowIconContainer>
            <ArrowForwardIosRoundedIcon color="primary" />
          </ArrowIconContainer>
        </OptionDiv>
      </PaymentMethodMainCard>
    );
  }
  return (
    <PaymentMethodMainCard>
      <OptionDiv onClick={handleMekiCreditsClick}>
        <OptionLeftContainer>
          <CardIcon creditCardType="Credits" />
          <TextDiv>
            <OptionTitleText>Usa tu dinero disponible</OptionTitleText>
            <OptionDescriptionText light>{label}</OptionDescriptionText>
          </TextDiv>
        </OptionLeftContainer>
        <ArrowIconContainer>
          <ArrowForwardIosRoundedIcon color="primary" />
        </ArrowIconContainer>
      </OptionDiv>
    </PaymentMethodMainCard>
  );
}
